import { IconProp } from '@fortawesome/fontawesome-svg-core';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Card, Col, Row } from 'react-bootstrap';
import KPIEvolutionChart from 'components/charts/KPIEvolutionChart';
import { formatMetricValue, MetricData } from 'helpers/utils';

interface KPIData {
  date: string;
  count: number;
}

interface CrmStatCardProps {
  icon: IconProp;
  color: string;
  label: string;
  title: string;
  valuetype: 'number' | 'percentage' | 'onedecimal' | 'text';
  value: number;
  data: KPIData[];
}

const CampaignPerformanceReportKPICard = ({
  icon,
  color,
  label,
  title,
  valuetype,
  value,
  data
}: CrmStatCardProps) => {
  const metricData: MetricData = {
    type: valuetype,
    value: value
  };

  return (
    <Card className="h-100" style={{ minWidth: '15rem' }}>
      <Card.Body className="p-3 pt-0 pb-1">
        <Row className="mb-2 border-bottom bg-body">
          <Col
            className="d-flex align-items-center"
            xs={7}
            sm={7}
            md={7}
            xl={7}
            xxl={7}
          >
            <div className={`d-flex pt-1`}>
              <FontAwesomeIcon
                icon={icon}
                className={`text-${color} fs-6 z-1 ms-2`}
              />
            </div>
            <p className="text-body-tertiary fs-10 mb-0 ms-2 mt-2 lh-1">
              {label} <br />
              <span className="p-0 fs-8 fw-bold lh-1 text-body-emphasis">
                {title}
              </span>
            </p>
          </Col>
          <Col
            className={`text-${color} mt-2 fs-6 fw-bold mb-0 pt-1 text-end`}
            xs={5}
            sm={5}
            md={5}
            xl={5}
            xxl={5}
          >
            {formatMetricValue(metricData)}
          </Col>
        </Row>
        <Row className="mb-0 mt-0">
          <div className="h-100">
            <KPIEvolutionChart data={data} />
          </div>
        </Row>
      </Card.Body>
    </Card>
  );
};

export default CampaignPerformanceReportKPICard;
